/**
 * Validation Mixin
 */
import scroll from './scroll'

export default {
  // Mixins
  mixins: [scroll],

  // Methods
  methods: {
    // Make sure the step is valid
    async validateStep (step) {
      try {
        if (step.submitted === false) step.submitted = true
        if (step.stepIsValid === false) throw new Error('Step Contains Invalid Fields.')
      } catch (error) {
        throw error
      }
    },

    // Validate the step order
    validateStepOrder (currentIndex, previousIndex, currentStep) {
      const subtractedValue = previousIndex - currentIndex

      // Prevent moving 'forward' in stepIndex history without submitting the step
      if (subtractedValue < 0 && !currentStep.submitted) {
        return true
      }

      // Prevent moving 'backwards' in stepIndex history after reloading the browser
      return Math.abs(subtractedValue) > 1
    },

    getMaxLengthErrorMessage (length) {
      return `Please enter less than ${length} characters. `
    }
  }
}
